"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const moment_1 = __importDefault(require("moment"));
const firstPageNumber = 1;
const initialState = {
    uiSelection: initialSearchOptions(),
    searchSelection: initialSearchOptions(),
    showResults: false,
    currentPage: firstPageNumber
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case "usage-statistics/TOOGLE_SALES_ORGANISATION_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { salesOrganisationFiltering: !state.uiSelection.salesOrganisationFiltering }) });
        case "usage-statistics/TOOGLE_SALES_ORGANISATION_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { salesOrganisationGrouping: !state.uiSelection.salesOrganisationGrouping }) });
        case "usage-statistics/TOOGLE_SYSTEM_TYPE_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { systemTypeFiltering: !state.uiSelection.systemTypeFiltering }) });
        case "usage-statistics/TOOGLE_SYSTEM_TYPE_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { systemTypeGrouping: !state.uiSelection.systemTypeGrouping }) });
        case "usage-statistics/TOOGLE_STATUS_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { statusFiltering: !state.uiSelection.statusFiltering }) });
        case "usage-statistics/TOOGLE_STATUS_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { statusGrouping: !state.uiSelection.statusGrouping }) });
        case "usage-statistics/TOOGLE_DATE_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { dateRangeFiltering: !state.uiSelection.dateRangeFiltering }) });
        case "usage-statistics/TOOGLE_DATE_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { dateRangeGrouping: !state.uiSelection.dateRangeGrouping }) });
        case "usage-statistics/TOOGLE_USER_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { usernameFiltering: !state.uiSelection.usernameFiltering }) });
        case "usage-statistics/TOOGLE_USER_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { usernameGrouping: !state.uiSelection.usernameGrouping }) });
        case "usage-statistics/TOOGLE_DELETED_SYSTEM_FILTERING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { deletedSystemFiltering: !state.uiSelection.deletedSystemFiltering }) });
        case "usage-statistics/TOOGLE_DELETED_SYSTEM_GROUPING":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { deletedSystemGrouping: !state.uiSelection.deletedSystemGrouping }) });
        case "usage-statistics/TOOGLE_GENESYS_NO":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { genesysNoShow: !state.uiSelection.genesysNoShow }) });
        case "usage-statistics/SELECTED_SALES_ORGANISATIONS":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedSalesOrganisations: action.payload }) });
        case "usage-statistics/SELECTED_SYSTEM_TYPES":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedSystemTypes: action.payload }) });
        case "usage-statistics/SELECTED_STATUS":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedStatus: action.payload }) });
        case "usage-statistics/SELECTED_DATE_START":
            const startDate = getStartOfLocalDay((0, moment_1.default)(action.payload));
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedDateStartString: action.payload, selectedDateRange: Object.assign(Object.assign({}, state.uiSelection.selectedDateRange), { start: startDate.isValid() ? startDate : undefined }) }) });
        case "usage-statistics/SELECTED_DATE_END":
            const endDate = getEndOfLocalDay((0, moment_1.default)(action.payload));
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedDateEndString: action.payload, selectedDateRange: Object.assign(Object.assign({}, state.uiSelection.selectedDateRange), { end: endDate.isValid() ? endDate : undefined }) }) });
        case "usage-statistics/SELECTED_USERNAME":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedUsername: action.payload }) });
        case "usage-statistics/SELECTED_DELETED_SYSTEMS":
            return Object.assign(Object.assign({}, state), { uiSelection: Object.assign(Object.assign({}, state.uiSelection), { selectedDeletedSystems: action.payload }) });
        case "usage-statistics/SHOW_RESULTS":
            return Object.assign(Object.assign({}, state), { showResults: true, searchSelection: Object.assign({}, state.uiSelection), currentPage: firstPageNumber });
        case "usage-statistics/CHANGE_PAGE":
            return Object.assign(Object.assign({}, state), { currentPage: action.payload.newPageNumber });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function initialSearchOptions() {
    const initialStartDate = (0, moment_1.default)().subtract({ days: 7 });
    const initialEndDate = (0, moment_1.default)();
    return {
        selectedSalesOrganisations: [],
        salesOrganisationGrouping: false,
        salesOrganisationFiltering: false,
        selectedSystemTypes: [],
        systemTypeGrouping: false,
        systemTypeFiltering: false,
        selectedStatus: [],
        statusGrouping: false,
        statusFiltering: false,
        selectedDeletedSystems: [],
        deletedSystemGrouping: false,
        deletedSystemFiltering: false,
        selectedDateRange: {
            start: getStartOfLocalDay(initialStartDate),
            end: getEndOfLocalDay(initialEndDate)
        },
        selectedDateStartString: initialStartDate.format("YYYY-MM-DD"),
        selectedDateEndString: initialEndDate.format("YYYY-MM-DD"),
        dateRangeGrouping: false,
        dateRangeFiltering: false,
        selectedUsername: "",
        usernameGrouping: false,
        usernameFiltering: false,
        genesysNoShow: false
    };
}
function toLocalDay(moment) {
    const m = moment.clone();
    return m.add(m.utcOffset(), "minutes");
}
function getStartOfLocalDay(moment) {
    let m = moment.clone();
    return toLocalDay(m.startOf("day"));
}
function getEndOfLocalDay(moment) {
    let m = moment.clone();
    return toLocalDay(m.endOf("day"));
}
//# sourceMappingURL=reducer.js.map